export const shouldLoad = () => document.querySelector('.klt-table-cell--multi-select') !== undefined;